require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-apoya-el-bid-los-derechos-de-los-indigenas-afrodescendientes.json") })
        }
      }, "path---es-mx-update-apoya-el-bid-los-derechos-de-los-indigenas-afrodescendientes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-apoya-el-bid-los-derechos-de-los-indigenas-afrodescendientes!./.cache/json/es-mx-update-apoya-el-bid-los-derechos-de-los-indigenas-afrodescendientes.json
// module id = 916
// module chunks = 231608221292675